/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedHalJson } from '../../models/paginated-hal-json';
import { TaxIdMappingRule } from '../../models/tax-id-mapping-rule';

export interface TaxIdMappingRulesGet$Params {
  'Active-Tenant-Identifier': string;
  channel?: Array<string>;
  start?: string;
  size?: number;
}

export function taxIdMappingRulesGet(http: HttpClient, rootUrl: string, params: TaxIdMappingRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: PaginatedHalJson;
'_embedded'?: {
'taxMappingRule'?: Array<TaxIdMappingRule>;
};
'size'?: number;
'count'?: number;
'currentStart'?: string;
'nextStart'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, taxIdMappingRulesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('channel', params.channel, {"style":"form","explode":true});
    rb.query('start', params.start, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: PaginatedHalJson;
      '_embedded'?: {
      'taxMappingRule'?: Array<TaxIdMappingRule>;
      };
      'size'?: number;
      'count'?: number;
      'currentStart'?: string;
      'nextStart'?: string;
      }>;
    })
  );
}

taxIdMappingRulesGet.PATH = '/tax-id-mapping-rules';
